class PatchSelector {
  constructor() {
    this.options = document.querySelectorAll('.patch-selector__option');
    this.selectedPatch = null;
    this.originalSlideIndex = 0;
    this.isAddingToCart = false;
    this.container = document.querySelector('.product__patch-selector');
    
    if (this.options.length === 0) return;
    
    this.init();
  }
  
  init() {
    // Store original main product image
    this.storeOriginalImage();
    
    // Add click handlers to patch options
    this.options.forEach(option => {
      option.addEventListener('click', () => this.selectPatch(option));
    });
    
    // Intercept the product form's cart add
    this.interceptCartAdd();
  }
  
  storeOriginalImage() {
    // Store the original slide index (usually 0, the first image)
    const mainGallery = document.querySelector('.js-media-list');
    if (mainGallery && mainGallery.swiper) {
      this.originalSlideIndex = mainGallery.swiper.activeIndex;
    } else {
      this.originalSlideIndex = 0; // Default to first slide
    }
  }
  
  selectPatch(option) {
    const isAlreadySelected = option.classList.contains('selected');
    
    // Remove selection from all options
    this.options.forEach(opt => opt.classList.remove('selected'));
    // Remove any existing "required" error if present
    this.clearRequiredError();
    
    if (isAlreadySelected) {
      // Deselect - return to original image
      this.selectedPatch = null;
      this.clearPatchData();
      this.restoreOriginalImage();
    } else {
      // Select new patch
      option.classList.add('selected');
      this.selectedPatch = {
        id: option.dataset.patchId,
        title: option.dataset.patchTitle,
        price: option.dataset.patchPrice,
        image: option.dataset.patchImage,
        variant: option.dataset.patchVariant
      };
      this.updatePatchData();
      this.switchToImageByAlt(this.selectedPatch.title);
    }
  }
  
  updatePatchData() {
    if (!this.selectedPatch) return;
    
    const patchIdInput = document.getElementById('bundledPatchId');
    const patchTitleInput = document.getElementById('bundledPatchTitle');
    const patchVariantInput = document.getElementById('bundledPatchVariant');
    
    if (patchIdInput) patchIdInput.value = this.selectedPatch.id;
    if (patchTitleInput) patchTitleInput.value = this.selectedPatch.title;
    if (patchVariantInput) patchVariantInput.value = this.selectedPatch.variant;
  }
  
  clearPatchData() {
    const patchIdInput = document.getElementById('bundledPatchId');
    const patchTitleInput = document.getElementById('bundledPatchTitle');
    const patchVariantInput = document.getElementById('bundledPatchVariant');
    
    if (patchIdInput) patchIdInput.value = '';
    if (patchTitleInput) patchTitleInput.value = '';
    if (patchVariantInput) patchVariantInput.value = '';
  }
  
  switchToImageByAlt(altText) {
    // Find the thumbnail in the sublist that matches the alt text
    const thumbnails = document.querySelectorAll('.product__media-subitem img');
    let matchingIndex = -1;
    
    thumbnails.forEach((img, index) => {
      if (img.alt && img.alt.includes(altText)) {
        matchingIndex = index;
        console.log(`Found matching image at index ${index}:`, img.alt);
      }
    });
    
    if (matchingIndex === -1) {
      console.warn(`No image found with alt text containing: "${altText}"`);
      return;
    }
    
    // Get the Swiper instance for the main image gallery
    const mainGallery = document.querySelector('.js-media-list');
    if (mainGallery && mainGallery.swiper) {
      mainGallery.swiper.slideTo(matchingIndex);
      console.log(`✅ Switched to slide ${matchingIndex}`);
    } else {
      console.error('Could not find Swiper instance');
    }
  }
  
  restoreOriginalImage() {
    // Switch back to the original slide index
    const mainGallery = document.querySelector('.js-media-list');
    if (mainGallery && mainGallery.swiper) {
      const indexToRestore = this.originalSlideIndex || 0;
      mainGallery.swiper.slideTo(indexToRestore);
      console.log(`✅ Restored to slide ${indexToRestore}`);
    }
  }
  
  interceptCartAdd() {
    // Listen for the cart:items-changed event (after successful add)
    document.addEventListener('product-form:added', async (e) => {
      if (this.selectedPatch && !this.isAddingToCart) {
        this.isAddingToCart = true;
        
        // Get the quantity that was just added
        const form = document.querySelector('product-form form');
        const quantity = form ? parseInt(form.querySelector('[name="quantity"]')?.value || '1') : 1;
        
        // Add the patch product
        await this.addPatchToCart(quantity);
        
        this.isAddingToCart = false;
      }
    });
    
    // Also intercept form submission to handle it ourselves when patch is selected
    const productForm = document.querySelector('product-form');
    if (productForm) {
      const form = productForm.querySelector('form');
      if (form) {
        form.addEventListener('submit', async (e) => {
          // If patch selector is present for this product, require a selection
          const requiresPatch = !!this.container;
          if (requiresPatch && !this.selectedPatch) {
            e.preventDefault();
            e.stopPropagation();
            this.showRequiredError();
            return;
          }

          if (this.selectedPatch && !this.isAddingToCart) {
            e.preventDefault();
            e.stopPropagation();
            
            this.isAddingToCart = true;
            await this.addBundleToCart(form);
            this.isAddingToCart = false;
          }
        }, true); // Use capture phase
      }
    }
  }
  
  showRequiredError() {
    if (!this.container) return;
    // Remove existing error if any
    this.clearRequiredError();
    const msg = document.createElement('div');
    msg.className = 'patch-selector__no-selection';
    msg.setAttribute('role', 'alert');
    msg.textContent = 'Please select a patch to continue.';
    this.container.appendChild(msg);
    // Scroll into view for visibility
    try {
      this.container.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (_) {}
  }

  clearRequiredError() {
    if (!this.container) return;
    const existing = this.container.querySelector('.patch-selector__no-selection');
    if (existing) existing.remove();
  }

  async addPatchToCart(quantity) {
    try {
      const patchData = {
        items: [{
          id: parseInt(this.selectedPatch.variant),
          quantity: quantity,
          properties: {
            '_bundled_with_main': document.querySelector('[name="product-title"]')?.value || 'Main Product'
          }
        }]
      };
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(patchData)
      });
      
      if (!response.ok) {
        const error = await response.json();
        console.error('Failed to add patch:', error);
      }
      
    } catch (error) {
      console.error('Error adding patch to cart:', error);
    }
  }
  
  async addBundleToCart(form) {
    const formData = new FormData(form);
    const mainProductVariantId = parseInt(formData.get('id'));
    const mainProductQuantity = parseInt(formData.get('quantity') || '1');
    
    // Disable the submit button
    const submitButton = form.querySelector('[type="submit"]');
    const originalButtonState = submitButton ? submitButton.disabled : false;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('loading');
    }
    
    try {
      // Collect all properties from the form
      const properties = {};
      for (let [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          const match = key.match(/properties\[(.*?)\]/);
          if (match && !match[1].includes('_bundled_patch')) {
            properties[match[1]] = value;
          }
        }
      }
      
      // Add bundling info
      properties['_bundled_with'] = this.selectedPatch.title;
      
      // Get sections to render from cart drawer
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];
      
      // Create a unique bundle ID based on timestamp
      const bundleId = Date.now().toString();
      
      // Add both products in a single request
      const bundleData = {
        items: [
          {
            id: mainProductVariantId,
            quantity: mainProductQuantity,
            properties: {
              ...properties,
              '_bundle_id': bundleId
            }
          },
          {
            id: parseInt(this.selectedPatch.variant),
            quantity: mainProductQuantity,
            properties: {
              '_bundled_with_main': formData.get('product-title') || 'Main Product',
              '_bundle_id': bundleId
            }
          }
        ],
        sections: sections,
        sections_url: window.location.pathname
      };
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bundleData)
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to add bundle to cart');
      }
      
      const result = await response.json();
      
      // Trigger cart refresh
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      
      // Update cart UI
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      
      if (cartDrawer) {
        cartDrawer.renderContents(result);
      } else if (cartNotification) {
        cartNotification.renderContents(result);
      } else {
        // Fallback: redirect to cart
        window.location.href = '/cart';
      }
      
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      
      // Show error message
      const errorDiv = document.createElement('div');
      errorDiv.className = 'product-form__error-message';
      errorDiv.style.cssText = 'color: red; margin-top: 1rem; padding: 1rem; background: rgba(255,0,0,0.1);';
      errorDiv.textContent = error.message || 'There was an error adding items to your cart. Please try again.';
      
      const patchSelector = document.querySelector('.product-form__patch-selector');
      if (patchSelector) {
        // Remove any existing error messages
        const existingError = patchSelector.querySelector('.product-form__error-message');
        if (existingError) existingError.remove();
        
        patchSelector.appendChild(errorDiv);
        
        // Remove after 5 seconds
        setTimeout(() => errorDiv.remove(), 5000);
      }
    } finally {
      // Re-enable the submit button
      if (submitButton) {
        submitButton.disabled = originalButtonState;
        submitButton.classList.remove('loading');
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new PatchSelector());
} else {
  new PatchSelector();
}

// Reinitialize on section reload (Shopify theme editor)
document.addEventListener('shopify:section:load', () => new PatchSelector());


function switchToImageByAlt(altText) {
    // Find the thumbnail in the sublist that matches the alt text
    const thumbnails = document.querySelectorAll('.product__media-subitem img');
    let matchingIndex = -1;
    
    thumbnails.forEach((img, index) => {
      if (img.alt && img.alt.includes(altText)) {
        matchingIndex = index;
        console.log(`Found matching image at index ${index}:`, img.alt);
      }
    });
    
    if (matchingIndex === -1) {
      console.error(`No image found with alt text containing: "${altText}"`);
      return;
    }
    
    // Get the Swiper instance for the main image gallery
    const mainGallery = document.querySelector('.js-media-list');
    if (mainGallery && mainGallery.swiper) {
      mainGallery.swiper.slideTo(matchingIndex);
      console.log(`✅ Switched to slide ${matchingIndex}`);
    } else {
      console.error('Could not find Swiper instance');
    }
  }
  
  // Usage examples:
  // switchToImageByAlt('On Watch Hat Patch');
  // switchToImageByAlt('We Serve Hat Patch');